import type { IncidentCategory } from '../../../interface/vesr';
import type { CancellationReason } from '../../../lib/cancellation-api';

export interface ICancellationReasonOption {
	value: CancellationReason;
	/** Tile label — what the agent saw happen, in their words. */
	label: string;
	/** Situation Room category for the neutral incident (contract §VESR). */
	vesrCategory: IncidentCategory;
}

/** Tile order: most likely first. The server receives `value` by NAME. */
export const CANCELLATION_REASONS: readonly ICancellationReasonOption[] = [
	{ value: 'Violence', label: 'Violence', vesrCategory: 'Security' },
	{ value: 'OverVoting', label: 'Over-voting', vesrCategory: 'Electoral' },
	{ value: 'BvasFailure', label: 'BVAS failed', vesrCategory: 'Technical' },
	{ value: 'MaterialsNotDelivered', label: 'Materials not delivered', vesrCategory: 'Logistics' },
	{ value: 'CourtOrder', label: 'Court order', vesrCategory: 'Electoral' },
	{ value: 'Other', label: 'Other', vesrCategory: 'Other' },
];

export const reasonLabel = (reason?: CancellationReason | null): string =>
	CANCELLATION_REASONS.find((r) => r.value === reason)?.label ?? 'Other';

export const reasonCategory = (reason: CancellationReason): IncidentCategory =>
	CANCELLATION_REASONS.find((r) => r.value === reason)?.vesrCategory ?? 'Other';
